import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#111111] text-[#e0e0e0] flex items-center justify-center px-6">
      <div className="max-w-md w-full border border-[#262626] bg-[#171717] p-10 text-center" data-testid="payment-cancel-page">
        <div className="mono text-xs uppercase tracking-widest text-[#facc15] mb-3">Direct Settlement</div>
        <h1 className="editorial text-4xl text-white mb-4">PAYMENT CANCELLED</h1>
        <p className="text-sm text-[#a3a3a3] leading-relaxed mb-8">
          No charge was made. Your delivery slot request is unaffected — you can complete the
          deposit whenever you are ready.
        </p>
        <Link
          to="/#booking"
          data-testid="payment-cancel-home-link"
          className="mono text-xs uppercase tracking-widest px-6 py-3.5 bg-[#facc15] text-black font-bold hover:bg-[#eab308] transition-colors inline-block"
        >
          Back to Booking
        </Link>
      </div>
    </div>
  );
}
